import * as React from 'react'
import { Collapse, Col, Row } from 'antd'
import moment from 'moment'
import { CollapsibleType } from 'antd/lib/collapse/CollapsePanel'

import { PraticaMutuoTimelineItemModel } from '../../model/PraticaModels'

import './TimelineCard.less'

import status_ok from '../../content/status_ok.svg'
import inoltrato from '../../content/inoltrato.svg'

const { Panel } = Collapse

interface TimelineCardProps {
    defaultExpandedNodes: Array<string>
    item: PraticaMutuoTimelineItemModel
}

export const TimelineCard: React.FC<TimelineCardProps> = (props) => {

    const renderIcon = (item: PraticaMutuoTimelineItemModel) => {
        if (item.StatoCorrente === true)
            return <img src={inoltrato} height="16px" alt="In lavorazione" aria-label="In lavorazione" />
        else if (item.StatoPassato === true)
            return <img src={status_ok} height="14px" alt="Completato" aria-label= "Completato"/>
        else
            return <></>
    }

    const renderDate = (item: PraticaMutuoTimelineItemModel) => {
        if (!item.Data) return
        return <span className="Regular12Grey800">{moment(item.Data).format('L')}</span>
    }

    const renderHeader = (item: PraticaMutuoTimelineItemModel) => {
        return (
            <Row justify="space-between" align="middle">
                <Col>
                    <span className="Bold15Grey800" style={{ textTransform: 'uppercase' }}>{item.Titolo}</span>
                </Col>
                <Col>{renderDate(item)}</Col>
            </Row>
        )
    }

    const isExpanded = (item: PraticaMutuoTimelineItemModel): boolean => {
        return props.defaultExpandedNodes.findIndex(e => item.Codice == e) > -1
    }

    const getDefaultKeys = (item: PraticaMutuoTimelineItemModel) => {
        return isExpanded(item) ? ["1"] : []
    }

    const isCollapible = (item: PraticaMutuoTimelineItemModel): CollapsibleType => {
        return item.StatoPassato === true ? null : "disabled"
    }

    let style = {}
    if (props.item.StatoPassato !== true)
        style = { opacity: '0.6' }

    return (
        <div className="timeline-card" style={style} aria-disabled={!props.item.StatoPassato}>
            <Collapse ghost defaultActiveKey={getDefaultKeys(props.item)} expandIcon={_ => renderIcon(props.item)} collapsible={isCollapible(props.item)} >
                <Panel key="1" header={renderHeader(props.item)} style={{ backgroundColor: 'white' }} >
                    <span aria-disabled={props.item.StatoPassato}  className="Regular15Grey800">{props.item.Descrizione}</span>
                </Panel>
            </Collapse>
        </div>
    )
}